var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clipart && _vm.clipart.clipart && _vm.clipart.clipart.file)?_c('div',[_c('show-image',{attrs:{"width":_vm.clipart.width,"height":_vm.clipart.height,"src":_vm.clipart.clipart.file,"alt":"CLIPART"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }